import React from 'react';
import moment from 'moment';
import cn from 'classnames';
import PropTypes from 'prop-types';

const Cell = ({ event, isLoading, onClick }) => (
  <div className={cn({
    'xti-calendar__cell': true,
    'xti-calendar__cell--empty': event.id === null,
    'xti-calendar__cell--loading': isLoading,
    [`xti-calendar__cell--${event.type}`]: !isLoading && event.type,
  })}
  >
    <div className="xti-calendar__cell-time">{event.start ? moment(event.start).format('H:mm') : ''}</div>
    <div className="xti-calendar__cell-title" onClick={() => onClick(event.id)}>{event.title}</div>
  </div>
);

Cell.defaultProps = {
  event: {},
  isActive: false,
};

Cell.propTypes = {
  event: PropTypes.shape({
    id: PropTypes.string,
    time: PropTypes.string,
    title: PropTypes.string,
  }),
  isActive: PropTypes.bool,
  onClick: PropTypes.func.isRequired,
};

export default Cell;
